import { useContext } from 'react';
import { Context } from '@components/Context';

export function useOrderTotals() {
  const { state } = useContext(Context);
  const { price, shippingCost, creditData, recurringPrice, tax } = state;

  // Total before applying credit
  const totalBeforeCredit = price + shippingCost.shippingPrice;

  // Use the smaller of the credit balance or the total cost
  const creditBalance = creditData?.currentBalance || 0;
  const appliedCredit = Math.min(creditBalance, totalBeforeCredit);

  // One-time total never goes negative.
  const oneTimeTotal = totalBeforeCredit - appliedCredit;

  // Subtotal (used for the taxes breakdown) remains price minus tax
  const subtotal = price - (tax || 0);

  // Recurring total is computed as before (credit is only applied once)
  const totalRecurringPrice = recurringPrice + shippingCost.shippingPrice;

  return {
    oneTimeTotal,
    subtotal,
    totalRecurringPrice,
    appliedCredit,
    creditBalance
  };
}
